<template>
    <div class="div-vm-loading">
        <table class="table table-striped table-vm-loading">
            <thead>
                <tr>
                    <th v-sort:product_number="sort">#</th>
                    <th v-sort:name="sort" class="text-nowrap">Продукты / ингредиенты</th>
                    <th v-sort:percent="sort" class="text-nowrap d-none d-sm-table-cell">Текущее кол-во</th>
                    <th class="text-center d-none d-sm-table-cell">Min</th>
                    <th class="d-none d-sm-table-cell" />
                    <th colspan="3" class="d-none d-sm-table-cell">Изменить кол-во</th>
                    <th class="text-center d-none d-sm-table-cell">Max</th>
                    <th class="text-center d-table-cell d-sm-none" />
                </tr>
            </thead>
            <ValidationObserver tag="tbody">
                <tr v-for="(item, index) in items" :key="index">
                    <td>{{ item.product_number }}</td>

                    <td class="truncate">
                        {{ item.name }}

                        <div class="d-flex d-sm-none align-items-center text-nowrap">
                            <vm-loading-level class="mr-3" :loading="item.current_loading + item.add" :max="item.max" />
                            <span>{{ item.current_loading + item.add | roundVolume }}/{{ item.max | roundVolume }} {{ item.unit | unit }}</span>
                        </div>
                    </td>

                    <td class="d-none d-sm-table-cell">
                        <div class="d-flex align-items-center text-nowrap">
                            <vm-loading-level class="mr-3" :loading="item.current_loading + item.add" :max="item.max" />
                            <span>{{ item.current_loading | roundVolume }}/{{ item.max | roundVolume }} {{ item.unit | unit }}</span>
                        </div>
                    </td>

                    <td class="text-center d-none d-sm-table-cell">
                        <button v-if="item.current_loading > 0" type="button" class="btn btn-link text-nowrap" @click="subMax(item)">
                            -{{ item.current_loading | roundVolume }}
                        </button>
                    </td>

                    <td class="text-center d-none d-sm-table-cell">
                        <button v-if="item.current_loading > 0" type="button" class="btn btn-link text-nowrap" @click="subSmall(item)">
                            -{{ item.unit | unitSmallVolume }}
                        </button>
                    </td>

                    <ValidationProvider v-errors tag="td" class="text-center form-group d-none d-sm-table-cell" rules="integer">
                        <volume-input :disabled="!item.max" placeholder="0" :value="item.add" :unit="item.unit" class="d-inline-block" @input="$emit('change', [ item, $event ])" />
                        <input v-model="item.add" type="hidden">
                    </ValidationProvider>

                    <td class="text-center d-none d-sm-table-cell">
                        <button v-if="item.max" type="button" class="btn btn-link text-nowrap" @click="addSmall(item)">
                            +{{ item.unit | unitSmallVolume | roundVolume }}
                        </button>
                    </td>

                    <td class="text-center d-none d-sm-table-cell">
                        <button v-if="item.max" type="button" class="btn btn-link text-nowrap" @click="addLarge(item)">
                            +{{ item.unit | unitLargeVolume | roundVolume }}
                        </button>
                    </td>

                    <td class="text-center d-none d-sm-table-cell">
                        <button v-if="item.max" type="button" class="btn btn-link text-nowrap" @click="addMax(item)">
                            <i class="tlm-icon-upload" />
                        </button>
                    </td>

                    <td class="text-center d-table-cell d-sm-none">
                        <button v-if="item.max" type="button" class="btn btn-edit" @click.prevent="edit(item)" />
                    </td>
                </tr>
            </ValidationObserver>

            <tfoot v-if="items.length === 0" class="no-one">
                <tr>
                    <td colspan="42">В автомате нет продуктов.</td>
                </tr>
            </tfoot>
        </table>

        <vm-loading-component v-if="editItem" :item="editItem" class="d-sm-none" @close="editItem = null" v-on="$listeners" />
    </div>
</template>

<script>
import { round, orderBy } from 'lodash'
import VolumeInput from '@/components/VolumeInput'
import VmLoadingLevel from '@/components/VmLoadingLevel'
import VmLoadingComponent from '@/components/VmLoadingComponent'

import { ValidationProvider, ValidationObserver } from 'vee-validate'

const unitSmallVolume = unit => {
    if (unit === 2) {
        return 100
    }

    if (unit === 3) {
        return 25
    }

    return 1
}

const unitLargeVolume = unit => {
    if (unit === 2) {
        return 5000
    }

    if (unit === 3) {
        return 100
    }

    return 10
}

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        VolumeInput,
        VmLoadingLevel,
        VmLoadingComponent
    },

    filters: {
        unitSmallVolume(unit) {
            return unitSmallVolume(unit)
        },

        unitLargeVolume(unit) {
            return unitLargeVolume(unit)
        },

        roundVolume(volume) {
            return volume >= 1000 ? round(volume / 1000, 2) + 'K' : volume
        }
    },

    props: {
        loading: {
            type: Array,
            default: _ => ([])
        }
    },

    data() {
        return {
            sort: null,
            editItem: null
        }
    },

    computed: {
        items() {
            const items = this.loading.map(item => {
                return {
                    ...item,
                    percent: round(item.current_loading + item.add / item.max * 100)
                }
            })

            return this.sort
                ? orderBy(items, this.sort.name, this.sort.order)
                : items
        }
    },

    methods: {
        subMax(item) {
            this.$emit('change', [ item, -1 * item.current_loading ])
        },

        subSmall(item) {
            const min = -1 * item.current_loading
            this.$emit('change', [ item, Math.max(item.add - unitSmallVolume(item.unit), min) ])
        },

        addSmall(item) {
            const max = item.max - item.current_loading
            this.$emit('change', [ item, Math.min(item.add + unitSmallVolume(item.unit), max) ])
        },

        addLarge(item) {
            const max = item.max - item.current_loading
            this.$emit('change', [ item, Math.min(item.add + unitLargeVolume(item.unit), max) ])
        },

        addMax(item) {
            this.$emit('change', [ item, item.max ])
        },

        edit(item) {
            this.editItem = item
        }
    }
}
</script>

<style lang="scss">
@import "../scss/_variables";

@media (min-width: 992px) {
    .div-vm-loading {
        overflow-y: auto;
        height: 65vh;
        margin: 1rem -1rem !important;
    }
    .table-vm-loading {
        width: 100% !important;
        margin: 0 !important;
    }
}

.table-vm-loading {
    td, th {
        /* padding-top: 1.25rem !important;
        padding-bottom: 1.25rem !important; */
        line-height: 3 !important;
    }

    th + th,
    td + td {
        padding-left: 0 !important;
    }

    .btn-link {
        padding-left: 0;
        padding-right: 0;
        font-size: $font-size-base;
        text-decoration: none;
        border: none;
    }

    i {
        vertical-align: sub;
    }

    .progress {
        width: 50px;
    }
}

</style>
